/**
 * Lifecycle of a store slice that is populated once from backend data. Kept generic so every
 * load-once reference slice (config, value-help, and future migrations) can report readiness
 * the same way, which is what a future NgRx-driven app-initialization orchestrator will gate on.
 *
 * Only `Idle` -> `Loaded` is wired today; `Loading` and `Error` exist for the dependency-aware
 * init mechanism that will drive the loads through effects. See the migration plan.
 */
export enum LoadStatus {
    Idle = 'idle',
    Loading = 'loading',
    Loaded = 'loaded',
    Error = 'error',
}
